import { Type } from '@angular/core';
import { AccessRequestEffects } from './access-request-fetch.effect';

export const effects: Type<AccessRequestEffects>[] = [
    AccessRequestEffects
];